<template>
  <div :class="$style.root">
    <Form>
      <Title>
        重置密碼
      </Title>
      <FormRow>
        <Input
          placeholder="密碼"
          v-model="password"
          type="password"
          :error="$v.password.$error"
        />
        <InputError v-if="$v.password.$error">
          <div v-if="!$v.password.required">請輸入新密碼</div>
        </InputError>
      </FormRow>
      <Buttons>
        <NextButton
          @click="handleSubmit"
          :disabled="isLoading"
          :loading="isLoading"
        />
      </Buttons>
      <Links :links="links" />
    </Form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import Input from '@/components/Input'
import InputError from '@/components/InputError'
import NextButton from '@/components/NextButton'
import Links from '@/components/Landing/Links'
import Form from '@/components/Landing/Form'
import FormRow from '@/components/Landing/FormRow'
import Buttons from '@/components/Landing/Buttons'
import Title from '@/components/Landing/Title'

export default {
  mixins: [validationMixin],
  components: {
    Input,
    InputError,
    NextButton,
    Links,
    Form,
    FormRow,
    Buttons,
    Title,
  },
  props: {
    userId: {
      required: true,
    },
    resetToken: {
      required: true,
    },
  },
  data () {
    return {
      password: '',
      isLoading: false,
    }
  },
  computed: {
    links () {
      return [
        { label: '登入', to: '/login' },
        { label: '用戶註冊', to: '/register' },
      ]
    },
  },
  methods: {
    async handleSubmit () {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }

      this.isLoading = true
      try {
        await this.httpPost({
          url: '/reset-password',
          data: {
            user_id: this.userId,
            reset_token: this.resetToken,
            password: this.password,
          },
        })
        this.$toasted.success('已設置新密碼，請重新登入', {
          duration: 2000,
          onComplete: () => {
            this.$router.push('/login')
          },
        })
      } catch (e) {
        this.$toasted.error('連結已失效，請重新申請')
      } finally {
        this.isLoading = false
      }
    },
    ...mapActions('http', {
      httpPost: 'post',
    }),
  },
  validations: {
    password: { required },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply h-full;
  @apply w-full;
  @apply flex;
  @apply justify-center;
}
</style>
